import { IlluminateInstall, IlluminateCustomize, Illuminate } from "illuminate/pages";
import StreamCategoriesAction from "illuminate/components/StreamCategoriesAction";
import StreamCategoriesModal from "illuminate/components/StreamCategoriesModal";
import IlluminateRoutes from "./Routes";
export const PAGE_NAV_TITLE = "Illuminate";
export default {
  "components.shared.entityActions": [
    {
      component: StreamCategoriesAction,
      key: "manage-stream-categories",
      modal: StreamCategoriesModal
    }
  ],
  routes: [
    { path: IlluminateRoutes.unqualified.LIST, component: Illuminate },
    { path: IlluminateRoutes.unqualified.CUSTOMIZATION, component: IlluminateCustomize },
    { path: IlluminateRoutes.unqualified.CUSTOMIZATION_DETAILS(":id"), component: IlluminateCustomize },
    { path: IlluminateRoutes.unqualified.INSTALL, component: IlluminateInstall }
  ],
  pageNavigation: [
    {
      description: PAGE_NAV_TITLE,
      children: [
        { description: "Content Hub", path: IlluminateRoutes.LIST, exactPathMatch: true },
        { description: "Customization", path: IlluminateRoutes.CUSTOMIZATION }
      ]
    }
  ]
};
